// 예: src/pages/MyPage/components/VersionInfo.jsx
import React from "react";
import { postToApp } from "../../../../bridges/appBridge";

function parseVersion(v) {
    // "v0.0.0" / "v.0.00" 둘 다 대비용
    if (!v) return [0, 0, 0];
    const digits = v.replace(/[^0-9.]/g, "").split(".");
    const [maj, min, patch] = [
        parseInt(digits[0] || "0", 10),
        parseInt(digits[1] || "0", 10),
        parseInt(digits[2] || "0", 10),
    ];
    return [maj, min, patch];
}

function isNewer(latest, current) {
    const [a1, a2, a3] = parseVersion(latest);
    const [b1, b2, b3] = parseVersion(current);
    if (a1 !== b1) return a1 > b1;
    if (a2 !== b2) return a2 > b2;
    return a3 > b3;
}



const VersionInfo = ({ currentVersion = "v0.00.00", latestVersion = "v0.00.00" }) => {
    const hasUpdate = isNewer(latestVersion, currentVersion);

    // console.log("[VersionInfo props]", { currentVersion, latestVersion });

    return (
        <div className="w-full flex flex-col">
            <span className="text-b1 text-text-subtle">
                버전 정보
            </span>

            {/* 현재 버전 */}
            <span className="pt-[8px]">
                <span className="text-text-disabled text-c2 pr-[8px]">현재 버전</span>
                <span className="text-text-subtler text-c1">{currentVersion}</span>
            </span>


            {/* 최신 버전 + 업데이트 문구 */}
            <div className="flex items-center gap-[8px] pt-[4px] border-b border-border-subtle pb-[40px]">
                <span className="text-text-disabled text-c2">
                    최신 버전
                </span>

                <span
                    className={`text-c1 ${hasUpdate ? "text-text-primary" : "text-text-subtler"
                        }`}
                >
                    {latestVersion}
                </span>

                {hasUpdate && (
                    <button
                        type="button"
                        className="text-c1 text-text-primary leading-none"
                        onClick={() => {
                            // RN 앱일 때 → App.js로 메시지 전송
                            postToApp({
                                type: "OPEN_APP_STORE",
                                payload: {}, // 필요하면 { source: 'version_banner' } 이런 식으로도 보낼 수 있고
                            });

                            // 혹시 브라우저에서 열렸을 때 대비해서
                            if (!window.ReactNativeWebView) {
                                window.open(
                                    "https://play.google.com/store/apps/details?id=com.wizmarket",
                                    "_blank"
                                );
                            }
                        }}
                    >
                        업데이트 하기
                    </button>
                )}
            </div>

        </div>
    );
};

export default VersionInfo;
